export default {
  // 2-12
  ins_choicelist: [],
  ins_applier: [],
  ins_applierlist: [],

  // 2-13
  ins_forcensor: [],
  ins_forcensorlist: [],
};
